<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Structure Withdrawals
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Approve for Final Status Form
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col lg="4"></b-col>
        <b-col lg="4"></b-col>
        <b-col lg="4">
          <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <hr>

     <b-card no-body v-if="inMyGroups(['Program PI'])">
        <b-tabs card fill>
          <b-tab :title="'NEW REQUESTS ('+structures.length+')'" active v-if="inMyGroups(['Ento Data Entry Clerk', 'Data Manager', 'Epi Lead'])">
            <b-card-text >
              <StructureFinalStatusRequestTable />
            </b-card-text>
          </b-tab>

          <b-tab :title="'READY FOR CLOSURE ('+final_structures.length+')'" v-if="inMyGroups(['Ento Data Entry Clerk', 'Site PI'])">
            <b-card-text >

              <b-table striped hover :fields="structure_list_fields" :items="final_structures" :filter="filter">
                <template v-slot:cell(date_requested)="data">
                  {{ data.item.structure_case.withdrawal_date }}
                </template>
                <template v-slot:cell(reason)="data">
                  {{ data.item.structure_case.final_status }}
                </template>
                <template v-slot:cell(approve)="data">
                
                    <!-- Only show approve/decline buttons for new requests -->
                    <b-button v-if="data.item.status == 'Final Status Form Completed'" @click="close(data.index)" size="sm" variant="success" class="w-20">Complete Withdrawal</b-button>

                    <!-- And for those that are already completed... -->
                    <div v-if="data.item.status == 'Closed'">
                      Closed on {{ data.item.last_status_changed }}
                    </div>
                    
                </template>
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
     </b-card>
     <div v-else>
       <StructureFinalStatusRequestTable />
     </div>
     

    <b-modal id="aesae_list_modal" size="xl" :title="active_aesae_modal_title" ok-only header-class="border-bottom-0">
      <!--  :fields="aesae_list_fields" -->
      <b-table striped hover :items="active_aesae_list" :filter="filter">
        <template v-slot:cell(ae_sae_id)="data">
          <b-link :href="data.item.case_link" target="_blank">{{ data.item.ae_sae_id }}</b-link>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import StructureFinalStatusRequestTable from "@/pages/unitaid/structure-withdrawal/StructureFinalStatusRequests.vue";

import { mapActions, mapState, mapGetters } from "vuex";

import * as moment from 'moment';

import * as _ from 'lodash';

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    StructureFinalStatusRequestTable
  },
  data: function() {
    return {
      structure_list_fields: [
        { key: "structure_id", label: "Structure ID" },
        { key: "date_requested" },
        { key: "status" },
        { key: "reason" },
        { key: "approve" }
      ],
      final_structures: [],
      structures: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters('user', ['inMyGroups'])
  },
  mounted: function() {
    let that = this;
     HTTP.get("/kenya/structures/get_withdrawal_followup_completes").then(response => {
       _.each(response.data, function(item){
         item.last_status_changed = moment(item.last_status_changed).format('MMM Do, YYYY');
       });
      that.final_structures = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });

    HTTP.get("/kenya/structures/get_withdrawal_requests").then(response => {
      that.structures = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectfinalstatuscompleted', 
            ['getSubjectFinalCompletedCount', 'setSubjectFinalCompletedCount']),
    refreshSideNavCount(){
      this.getSubjectFinalCompletedCount().then((response) => {
                this.setSubjectFinalCompletedCount(response.data);
            });
    },
    close: function(index){
      let that = this;
      HTTP.post("/kenya/structure/status/"+that.final_structures[index].id+"/", {
        status: 'close'
      }).then(response => {
          that.final_structures.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
  }
};
</script>

<style>
</style>